module.exports = __webpack_public_path__ + "img/gamstop-colour.b3d1d819.svg";